const sensors = require('sa-sdk-javascript');
let shengceServer_url = "http://spare3.haolangtech.com/web/getData"; //外网测试环境
sensors.init({

  show_log: true,

  server_url: shengceServer_url, // 神策数据接收地址

  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件

  send_type: 'ajax',
  scrollmap: {
    collect_url: function(){
      //如果只采集首页
      if(location.pathname === '/activity/activityview' || location.pathname === '/activity/activityjoin'){
        return true;
      }
    },
  },
  heatmap: {

    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    collect_url: function(){
    		//如果只采集首页
    		if(location.pathname === '/activity/activityview' || location.pathname === '/activity/activityjoin'){
    			return true;
    		}
    	},
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',


  }

});

const param = {
  app_id: 123,
  platform_type: 'WEB', // 平台类型：App，H5，Web
  app_name: '活动圈', // 应用名称
}
sensors.registerPage(param);

sensors.quick('autoTrack');
export default sensors;



// WEBPACK FOOTER //
// ./src/assets/js/sensors_config.js